'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var siteNavComponent = exports.siteNavComponent = {
    template: require('./site-nav.html'),
    bindings: {
        navigationData: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "$element", "$state", "localizer", "authService", function controller(common, $element, $state, localizer, authService) {
        'ngInject';

        var vm = this;
        vm.isSellerActive = true;
        vm.currentLanguage = common.localization.getCurrentLanguage();
        vm.toggleMenu = toggleMenu;
        vm.hideMenu = hideMenu;
        vm.toggleSubmenu = toggleSubmenu;
        vm.hideSubmenu = hideSubmenu;
        vm.preventDefault = function (e) {
            e.preventDefault();
        };
        vm.$onInit = init;
        vm.desktopMenuThreshold = 768;
        vm.currentLanguage = localizer.getCurrentLanguage();
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.setLanguage = setLanguage;
        vm.outletIsActive = outletIsActive;

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }

        function setLanguage(language) {
            localizer.setLanguage(language);
            $state.go('.', { language: language });
        }

        function init() {
            /*$element.find('a.has-sub').on('click', function(e){ 

                e.preventDefault();
                angular.element(e.currentTarget.parentElement).toggleClass('is-open');
            });*/
            $element.on('click', 'a:not(.has-sub)', function () {
                angular.element('html').toggleClass('site-nav-is-open', false);
                vm.hideSubmenu();
            });
        }

        function toggleMenu() {
            angular.element('html').toggleClass('site-nav-is-open');
        }

        function hideMenu() {
            angular.element('html').toggleClass('site-nav-is-open', false);
        }
        function outletIsActive() {
            return vm.navigationData.sellers.find(function (x) {
                return x.code === 'OUT';
            });
        }
        function toggleSubmenu(e) {
            e.preventDefault();
            var parent = angular.element(e.currentTarget.parentElement);
            var isOpen = parent.hasClass('is-open');
            if (!isOpen && window.innerWidth >= vm.desktopMenuThreshold) {
                // when opens ==> close others
                parent.siblings('.is-open').removeClass('is-open');
            }
            parent.toggleClass('is-open');
        }

        function hideSubmenu() {
            $element.find('.site-nav').find('.is-open').removeClass('is-open');
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/layout/site-nav.js
// module id = 943
// module chunks = 0